/*! Bead Yours core - shared by the Perler builder, jewelry builder and pattern sheet.
    Plain JS, no dependencies. Exposes window.BeadYours (BY). */
(function (g) {
  'use strict';
  var BY = g.BeadYours = g.BeadYours || {};
  BY.version = '1.0.0';

  /* ------------------------------------------------------------------ *
   * Color math
   * ------------------------------------------------------------------ */
  function hexToRgb(hex) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function rgbToHex(rgb) {
    return '#' + rgb.map(function (v) {
      var s = Math.max(0, Math.min(255, Math.round(v))).toString(16);
      return s.length === 1 ? '0' + s : s;
    }).join('').toUpperCase();
  }
  function lin(c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  function rgbToLab(rgb) {
    var r = lin(rgb[0]), gg = lin(rgb[1]), b = lin(rgb[2]);
    var x = (r * 0.4124564 + gg * 0.3575761 + b * 0.1804375) / 0.95047;
    var y = (r * 0.2126729 + gg * 0.7151522 + b * 0.0721750);
    var z = (r * 0.0193339 + gg * 0.1191920 + b * 0.9503041) / 1.08883;
    function f(t) { return t > 0.008856 ? Math.cbrt(t) : (7.787 * t + 16 / 116); }
    var fx = f(x), fy = f(y), fz = f(z);
    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }
  // CIEDE2000 color difference
  function deltaE(l1, l2) {
    var L1 = l1[0], a1 = l1[1], b1 = l1[2], L2 = l2[0], a2 = l2[1], b2 = l2[2];
    var C1 = Math.sqrt(a1 * a1 + b1 * b1), C2 = Math.sqrt(a2 * a2 + b2 * b2);
    var Cb7 = Math.pow((C1 + C2) / 2, 7);
    var G = 0.5 * (1 - Math.sqrt(Cb7 / (Cb7 + 6103515625)));
    var a1p = (1 + G) * a1, a2p = (1 + G) * a2;
    var C1p = Math.sqrt(a1p * a1p + b1 * b1), C2p = Math.sqrt(a2p * a2p + b2 * b2);
    var h1p = (b1 === 0 && a1p === 0) ? 0 : Math.atan2(b1, a1p); if (h1p < 0) h1p += 2 * Math.PI;
    var h2p = (b2 === 0 && a2p === 0) ? 0 : Math.atan2(b2, a2p); if (h2p < 0) h2p += 2 * Math.PI;
    var dLp = L2 - L1, dCp = C2p - C1p, dhp = 0;
    if (C1p * C2p !== 0) {
      dhp = h2p - h1p;
      if (dhp > Math.PI) dhp -= 2 * Math.PI; else if (dhp < -Math.PI) dhp += 2 * Math.PI;
    }
    var dHp = 2 * Math.sqrt(C1p * C2p) * Math.sin(dhp / 2);
    var Lbp = (L1 + L2) / 2, Cbp = (C1p + C2p) / 2, hbp;
    if (C1p * C2p === 0) hbp = h1p + h2p;
    else {
      hbp = (h1p + h2p) / 2;
      if (Math.abs(h1p - h2p) > Math.PI) hbp += (h1p + h2p < 2 * Math.PI) ? Math.PI : -Math.PI;
    }
    var T = 1 - 0.17 * Math.cos(hbp - Math.PI / 6) + 0.24 * Math.cos(2 * hbp) +
      0.32 * Math.cos(3 * hbp + Math.PI / 30) - 0.20 * Math.cos(4 * hbp - 63 * Math.PI / 180);
    var dTheta = (Math.PI / 6) * Math.exp(-Math.pow((hbp * 180 / Math.PI - 275) / 25, 2));
    var Cbp7 = Math.pow(Cbp, 7);
    var Rc = 2 * Math.sqrt(Cbp7 / (Cbp7 + 6103515625));
    var Sl = 1 + (0.015 * Math.pow(Lbp - 50, 2)) / Math.sqrt(20 + Math.pow(Lbp - 50, 2));
    var Sc = 1 + 0.045 * Cbp, Sh = 1 + 0.015 * Cbp * T, Rt = -Math.sin(2 * dTheta) * Rc;
    return Math.sqrt(Math.pow(dLp / Sl, 2) + Math.pow(dCp / Sc, 2) + Math.pow(dHp / Sh, 2) + Rt * (dCp / Sc) * (dHp / Sh));
  }
  function luminance(rgb) { return 0.2126 * lin(rgb[0]) + 0.7152 * lin(rgb[1]) + 0.0722 * lin(rgb[2]); }
  BY.color = { hexToRgb: hexToRgb, rgbToHex: rgbToHex, rgbToLab: rgbToLab, deltaE: deltaE, luminance: luminance };

  /* ------------------------------------------------------------------ *
   * Perler palette (data from by-palette.js)
   * ------------------------------------------------------------------ */
  BY.PERLER = (BY.PERLER_RAW || []).map(function (r, i) {
    var rgb = hexToRgb(r[2]);
    return { id: i + 1, code: r[0], name: r[1], hex: r[2], type: r[3], status: r[4], core: !!r[5], rgb: rgb, lab: rgbToLab(rgb), light: luminance(rgb) > 0.45 };
  });
  var perlerByCode = {};
  BY.PERLER.forEach(function (c) { perlerByCode[c.code] = c; });
  BY.perlerByCode = function (code) { return perlerByCode[code] || null; };
  BY.perlerById = function (id) { return BY.PERLER[id - 1] || null; };
  BY.perlerId = function (code) { var c = perlerByCode[code]; return c ? c.id : 0; };

  // Colors offered in the builder. Theme config may pass an explicit list of codes.
  BY.enabledPerler = function (codes) {
    if (codes && codes.length) {
      return codes.map(function (c) { return perlerByCode[c]; }).filter(function (c) { return c && c.status !== 'discontinued'; });
    }
    return BY.PERLER.filter(function (c) { return c.core; });
  };
  BY.allCurrentPerler = function () { return BY.PERLER.filter(function (c) { return c.status === 'current'; }); };

  BY.nearestPerler = function (rgb, candidates, cache) {
    var key = (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
    if (cache && cache.has(key)) return cache.get(key);
    var lab = rgbToLab(rgb), best = null, bestD = Infinity;
    for (var i = 0; i < candidates.length; i++) {
      var d = deltaE(lab, candidates[i].lab);
      if (d < bestD) { bestD = d; best = candidates[i]; }
    }
    if (cache) cache.set(key, best);
    return best;
  };

  /* ------------------------------------------------------------------ *
   * Binary helpers: varint + base64url
   * ------------------------------------------------------------------ */
  function pushVarint(arr, n) { while (n >= 128) { arr.push((n & 127) | 128); n = Math.floor(n / 128); } arr.push(n); }
  function readVarint(bytes, pos) {
    var n = 0, mul = 1, b;
    do { b = bytes[pos.i++]; if (b === undefined) throw new Error('truncated'); n += (b & 127) * mul; mul *= 128; } while (b & 128);
    return n;
  }
  function b64urlEncode(bytes) {
    var s = '';
    for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(str) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    var s = atob(str), out = new Uint8Array(s.length);
    for (var i = 0; i < s.length; i++) out[i] = s.charCodeAt(i);
    return out;
  }
  function utf8ToB64url(str) {
    var bytes = new TextEncoder().encode(str);
    return b64urlEncode(bytes);
  }
  function b64urlToUtf8(str) { return new TextDecoder().decode(b64urlDecode(str)); }
  BY.b64 = { encode: b64urlEncode, decode: b64urlDecode, fromText: utf8ToB64url, toText: b64urlToUtf8 };

  /* ------------------------------------------------------------------ *
   * Perler design codes:  p1.<w>x<h>.<code-code-...>.<rle base64url>
   * grid = Uint8Array of global palette ids (0 = empty peg)
   * ------------------------------------------------------------------ */
  BY.encodePerler = function (w, h, grid) {
    var used = [], local = new Map();
    for (var i = 0; i < grid.length; i++) {
      var v = grid[i];
      if (v && !local.has(v)) { local.set(v, used.length + 1); used.push(BY.perlerById(v).code); }
    }
    var bytes = [];
    i = 0;
    while (i < grid.length) {
      var cur = grid[i] ? local.get(grid[i]) : 0, run = 1;
      while (i + run < grid.length && (grid[i + run] ? local.get(grid[i + run]) : 0) === cur) run++;
      pushVarint(bytes, cur); pushVarint(bytes, run);
      i += run;
    }
    return 'p1.' + w + 'x' + h + '.' + used.join('-') + '.' + b64urlEncode(bytes);
  };
  BY.decodePerler = function (code) {
    code = String(code || '').trim();
    var m = /^p1\.(\d+)x(\d+)\.([A-Za-z0-9-]*)\.([A-Za-z0-9_-]*)$/.exec(code);
    if (!m) throw new Error('Not a Bead Yours Perler design code');
    var w = +m[1], h = +m[2];
    if (!w || !h || w > 200 || h > 200) throw new Error('Bad size');
    var codes = m[3] ? m[3].split('-') : [];
    var ids = codes.map(function (c) { return BY.perlerId(c); });
    var bytes = b64urlDecode(m[4]), grid = new Uint8Array(w * h), pos = { i: 0 }, k = 0;
    while (pos.i < bytes.length && k < grid.length) {
      var v = readVarint(bytes, pos), run = readVarint(bytes, pos);
      var id = v ? (ids[v - 1] || 0) : 0;
      for (var r = 0; r < run && k < grid.length; r++) grid[k++] = id;
    }
    return { w: w, h: h, grid: grid, codes: codes };
  };

  // Bead counts per color: [{color, count}] sorted by count desc
  BY.perlerCounts = function (grid) {
    var counts = new Map();
    for (var i = 0; i < grid.length; i++) if (grid[i]) counts.set(grid[i], (counts.get(grid[i]) || 0) + 1);
    var out = [];
    counts.forEach(function (n, id) { out.push({ color: BY.perlerById(id), count: n }); });
    out.sort(function (a, b) { return b.count - a.count; });
    return out;
  };
  // Bounding box of placed beads
  BY.perlerBounds = function (w, h, grid) {
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) if (grid[y * w + x]) {
      if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y;
    }
    if (maxX < 0) return null;
    return { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
  };
  BY.PEG_MM = 5.0;
  BY.pegsToInches = function (n) { return n * BY.PEG_MM / 25.4; };
  BY.fmtInches = function (n) { var v = BY.pegsToInches(n); return (Math.round(v * 10) / 10) + '"'; };

  /* ------------------------------------------------------------------ *
   * Perler rendering
   * mode: 'pixels' | 'beads' | 'fused'
   * ------------------------------------------------------------------ */
  BY.drawPerler = function (ctx, w, h, grid, opt) {
    opt = opt || {};
    var cell = opt.cell || 10, ox = opt.x || 0, oy = opt.y || 0, mode = opt.mode || 'beads';
    var bg = opt.background === undefined ? null : opt.background;
    if (bg) { ctx.fillStyle = bg; ctx.fillRect(ox, oy, w * cell, h * cell); }
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var id = grid[y * w + x];
        var px = ox + x * cell, py = oy + y * cell;
        if (!id) {
          if (opt.pegs) {
            ctx.fillStyle = opt.pegColor || 'rgba(120,120,140,.18)';
            ctx.beginPath(); ctx.arc(px + cell / 2, py + cell / 2, Math.max(1, cell * 0.12), 0, Math.PI * 2); ctx.fill();
          }
          continue;
        }
        var c = BY.perlerById(id);
        if (mode === 'pixels') {
          ctx.fillStyle = c.hex; ctx.fillRect(px, py, cell, cell);
        } else if (mode === 'fused') {
          ctx.fillStyle = c.hex; ctx.fillRect(px - 0.25, py - 0.25, cell + 0.5, cell + 0.5);
          if (cell >= 6) {
            ctx.fillStyle = 'rgba(0,0,0,.18)';
            ctx.beginPath(); ctx.arc(px + cell / 2, py + cell / 2, cell * 0.14, 0, Math.PI * 2); ctx.fill();
          }
        } else {
          var r = cell * 0.47;
          ctx.fillStyle = c.hex;
          ctx.beginPath(); ctx.arc(px + cell / 2, py + cell / 2, r, 0, Math.PI * 2); ctx.fill();
          if (c.light && cell >= 5) { ctx.strokeStyle = 'rgba(40,30,60,.22)'; ctx.lineWidth = Math.max(0.75, cell * 0.06); ctx.stroke(); }
          if (cell >= 7) {
            ctx.fillStyle = c.light ? 'rgba(0,0,0,.22)' : 'rgba(0,0,0,.38)';
            ctx.beginPath(); ctx.arc(px + cell / 2, py + cell / 2, r * 0.38, 0, Math.PI * 2); ctx.fill();
            ctx.fillStyle = 'rgba(255,255,255,.28)';
            ctx.beginPath(); ctx.arc(px + cell * 0.36, py + cell * 0.32, r * 0.2, 0, Math.PI * 2); ctx.fill();
          }
        }
      }
    }
  };

  // PNG data URL of a design (trimmed to its beads unless opt.full)
  BY.perlerThumb = function (w, h, grid, size, opt) {
    opt = opt || {};
    var b = opt.full ? { x: 0, y: 0, w: w, h: h } : (BY.perlerBounds(w, h, grid) || { x: 0, y: 0, w: w, h: h });
    var sub = new Uint8Array(b.w * b.h);
    for (var y = 0; y < b.h; y++) for (var x = 0; x < b.w; x++) sub[y * b.w + x] = grid[(y + b.y) * w + (x + b.x)];
    var pad = opt.pad === undefined ? 1 : opt.pad;
    var cell = Math.max(1, Math.floor(size / (Math.max(b.w, b.h) + pad * 2)));
    var cv = document.createElement('canvas');
    cv.width = (b.w + pad * 2) * cell; cv.height = (b.h + pad * 2) * cell;
    var ctx = cv.getContext('2d');
    if (opt.background) { ctx.fillStyle = opt.background; ctx.fillRect(0, 0, cv.width, cv.height); }
    BY.drawPerler(ctx, b.w, b.h, sub, { cell: cell, x: pad * cell, y: pad * cell, mode: opt.mode || (cell >= 7 ? 'beads' : 'pixels') });
    return cv.toDataURL('image/png');
  };

  /* ------------------------------------------------------------------ *
   * Jewelry design codes: j1.<base64url(JSON)>
   * ------------------------------------------------------------------ */
  BY.encodeJewelry = function (d) { return 'j1.' + utf8ToB64url(JSON.stringify(d)); };
  BY.decodeJewelry = function (code) {
    code = String(code || '').trim();
    if (code.indexOf('j1.') !== 0) throw new Error('Not a Bead Yours jewelry design code');
    return JSON.parse(b64urlToUtf8(code.slice(3)));
  };

  /* ------------------------------------------------------------------ *
   * Pixel fonts (rows of bits, MSB = left)
   * ------------------------------------------------------------------ */
  function glyphs(src, width) {
    var out = {};
    Object.keys(src).forEach(function (ch) {
      out[ch] = src[ch].split('/').map(function (row) {
        var bits = []; for (var i = 0; i < width; i++) bits.push(row[i] === '#' ? 1 : 0); return bits;
      });
    });
    return out;
  }
  var F57 = {
    A: '.###./#...#/#...#/#####/#...#/#...#/#...#', B: '####./#...#/#...#/####./#...#/#...#/####.',
    C: '.###./#...#/#..../#..../#..../#...#/.###.', D: '####./#...#/#...#/#...#/#...#/#...#/####.',
    E: '#####/#..../#..../####./#..../#..../#####', F: '#####/#..../#..../####./#..../#..../#....',
    G: '.###./#...#/#..../#.###/#...#/#...#/.####', H: '#...#/#...#/#...#/#####/#...#/#...#/#...#',
    I: '.###./..#../..#../..#../..#../..#../.###.', J: '..###/...#./...#./...#./...#./#..#./.##..',
    K: '#...#/#..#./#.#../##.../#.#../#..#./#...#', L: '#..../#..../#..../#..../#..../#..../#####',
    M: '#...#/##.##/#.#.#/#.#.#/#...#/#...#/#...#', N: '#...#/#...#/##..#/#.#.#/#..##/#...#/#...#',
    O: '.###./#...#/#...#/#...#/#...#/#...#/.###.', P: '####./#...#/#...#/####./#..../#..../#....',
    Q: '.###./#...#/#...#/#...#/#.#.#/#..#./.##.#', R: '####./#...#/#...#/####./#.#../#..#./#...#',
    S: '.####/#..../#..../.###./....#/....#/####.', T: '#####/..#../..#../..#../..#../..#../..#..',
    U: '#...#/#...#/#...#/#...#/#...#/#...#/.###.', V: '#...#/#...#/#...#/#...#/#...#/.#.#./..#..',
    W: '#...#/#...#/#...#/#.#.#/#.#.#/#.#.#/.#.#.', X: '#...#/#...#/.#.#./..#../.#.#./#...#/#...#',
    Y: '#...#/#...#/.#.#./..#../..#../..#../..#..', Z: '#####/....#/...#./..#../.#.../#..../#####',
    '0': '.###./#...#/#..##/#.#.#/##..#/#...#/.###.', '1': '..#../.##../..#../..#../..#../..#../.###.',
    '2': '.###./#...#/....#/...#./..#../.#.../#####', '3': '####./....#/....#/.###./....#/....#/####.',
    '4': '...#./..##./.#.#./#..#./#####/...#./...#.', '5': '#####/#..../####./....#/....#/#...#/.###.',
    '6': '.###./#..../#..../####./#...#/#...#/.###.', '7': '#####/....#/...#./..#../.#.../.#.../.#...',
    '8': '.###./#...#/#...#/.###./#...#/#...#/.###.', '9': '.###./#...#/#...#/.####/....#/....#/.###.',
    '!': '..#../..#../..#../..#../..#../...../..#..', '?': '.###./#...#/....#/...#./..#../...../..#..',
    '.': '...../...../...../...../...../...../..#..', ',': '...../...../...../...../...../..#../.#...',
    "'": '..#../..#../...../...../...../...../.....', '-': '...../...../...../#####/...../...../.....',
    '+': '...../..#../..#../#####/..#../..#../.....', '&': '.##../#..#./#.#../.#.../#.#.#/#..#./.##.#',
    '#': '.#.#./.#.#./#####/.#.#./#####/.#.#./.#.#.', '*': '...../#.#.#/.###./#####/.###./#.#.#/.....',
    '♥': '...../.#.#./#####/#####/.###./..#../.....', '★': '..#../..#../#####/.###./.###./#...#/.....',
    ':': '...../..#../...../...../...../..#../.....', '/': '....#/....#/...#./..#../.#.../#..../#....'
  };
  var F35 = {
    A: '.#./#.#/###/#.#/#.#', B: '##./#.#/##./#.#/##.', C: '.##/#../#../#../.##', D: '##./#.#/#.#/#.#/##.',
    E: '###/#../##./#../###', F: '###/#../##./#../#..', G: '.##/#../#.#/#.#/.##', H: '#.#/#.#/###/#.#/#.#',
    I: '###/.#./.#./.#./###', J: '..#/..#/..#/#.#/.#.', K: '#.#/#.#/##./#.#/#.#', L: '#../#../#../#../###',
    M: '#.#/###/###/#.#/#.#', N: '##./#.#/#.#/#.#/#.#', O: '.#./#.#/#.#/#.#/.#.', P: '##./#.#/##./#../#..',
    Q: '.#./#.#/#.#/##./.##', R: '##./#.#/##./#.#/#.#', S: '.##/#../.#./..#/##.', T: '###/.#./.#./.#./.#.',
    U: '#.#/#.#/#.#/#.#/###', V: '#.#/#.#/#.#/#.#/.#.', W: '#.#/#.#/###/###/#.#', X: '#.#/#.#/.#./#.#/#.#',
    Y: '#.#/#.#/.#./.#./.#.', Z: '###/..#/.#./#../###',
    '0': '###/#.#/#.#/#.#/###', '1': '.#./##./.#./.#./###', '2': '##./..#/.#./#../###', '3': '##./..#/.#./..#/##.',
    '4': '#.#/#.#/###/..#/..#', '5': '###/#../##./..#/##.', '6': '.##/#../###/#.#/###', '7': '###/..#/.#./.#./.#.',
    '8': '###/#.#/###/#.#/###', '9': '###/#.#/###/..#/##.', '!': '.#./.#./.#./.../.#.', '?': '##./..#/.#./.../.#.',
    '.': '.../.../.../.../.#.', '-': '.../.../###/.../...', '+': '.../.#./###/.#./...', '♥': '#.#/###/###/.#./...',
    "'": '.#./.#./.../.../...', '&': '.#./#.#/.#./#.#/.##', ':': '.../.#./.../.#./...', '*': '#.#/.#./#.#/.../...'
  };
  BY.FONTS = {
    regular: { name: 'Regular', h: 7, w: 5, gap: 1, space: 3, glyphs: glyphs(F57, 5) },
    small: { name: 'Small', h: 5, w: 3, gap: 1, space: 2, glyphs: glyphs(F35, 3) }
  };
  // Rasterize text into a bitmap {w, h, bits:Uint8Array}. Supports \n.
  BY.rasterText = function (text, fontKey, opt) {
    opt = opt || {};
    var font = BY.FONTS[fontKey] || BY.FONTS.regular, scale = opt.scale || 1, lineGap = opt.lineGap === undefined ? 2 : opt.lineGap;
    var lines = String(text || '').toUpperCase().split('\n');
    var widths = lines.map(function (line) {
      var wsum = 0;
      for (var i = 0; i < line.length; i++) {
        var ch = line[i];
        wsum += (ch === ' ' ? font.space : (font.glyphs[ch] ? font.w : 0)) + (i < line.length - 1 ? font.gap : 0);
      }
      return wsum;
    });
    var W = Math.max.apply(null, widths.concat([0])) * scale;
    var H = (lines.length * font.h + (lines.length - 1) * lineGap) * scale;
    var bits = new Uint8Array(Math.max(1, W * H));
    lines.forEach(function (line, li) {
      var x = Math.floor((W / scale - widths[li]) / 2), y0 = li * (font.h + lineGap);
      for (var i = 0; i < line.length; i++) {
        var ch = line[i];
        if (ch === ' ') { x += font.space + font.gap; continue; }
        var gl = font.glyphs[ch]; if (!gl) continue;
        for (var gy = 0; gy < font.h; gy++) for (var gx = 0; gx < font.w; gx++) {
          if (!gl[gy][gx]) continue;
          for (var sy = 0; sy < scale; sy++) for (var sx = 0; sx < scale; sx++) {
            var X = (x + gx) * scale + sx, Y = (y0 + gy) * scale + sy;
            if (X < W && Y < H) bits[Y * W + X] = 1;
          }
        }
        x += font.w + font.gap;
      }
    });
    return { w: W, h: H, bits: bits };
  };

  /* ------------------------------------------------------------------ *
   * Shop helpers (Shopify AJAX APIs)
   * ------------------------------------------------------------------ */
  var productCache = {};
  BY.root = function () { return (g.Shopify && g.Shopify.routes && g.Shopify.routes.root) || '/'; };
  BY.fetchProduct = function (handle) {
    if (!handle) return Promise.reject(new Error('No product handle configured'));
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch(BY.root() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('Product "' + handle + '" not found'); return r.json(); })
      .catch(function (e) { delete productCache[handle]; throw e; });
    return productCache[handle];
  };
  // Find a variant whose option values include every wanted value (case-insensitive)
  BY.findVariant = function (product, wanted) {
    if (!product) return null;
    wanted = (wanted || []).map(function (v) { return String(v).toLowerCase(); });
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var opts = (v.options || [v.option1, v.option2, v.option3]).filter(Boolean).map(function (o) { return String(o).toLowerCase(); });
      if (wanted.every(function (w) { return opts.indexOf(w) >= 0; })) return v;
    }
    return null;
  };
  BY.cartAdd = function (items) {
    return fetch(BY.root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        return j;
      });
    });
  };
  BY.money = function (cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || (g.Shopify && g.Shopify.currency && g.Shopify.currency.active) || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ------------------------------------------------------------------ *
   * Small DOM + misc helpers
   * ------------------------------------------------------------------ */
  BY.h = function (tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') el.className = v;
      else if (k === 'text') el.textContent = v;
      else if (k === 'html') el.innerHTML = v;
      else if (k === 'style' && typeof v === 'object') Object.assign(el.style, v);
      else if (k.indexOf('on') === 0 && typeof v === 'function') el.addEventListener(k.slice(2), v);
      else if (v === true) el.setAttribute(k, '');
      else el.setAttribute(k, v);
    });
    (kids || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  };
  /* Share in Customer Creations: checkbox + optional credit name (shown when ticked). */
  BY.shareBlock = function (state, onChange, idPrefix) {
    var h = BY.h, wrap, box, credit;
    box = h('input', { type: 'checkbox', id: (idPrefix || 'by-share-') + BY.uid(), onchange: function () { state.share = this.checked; wrap.hidden = !this.checked; onChange(); } });
    credit = h('input', { class: 'by-input by-credit', type: 'text', maxlength: '30', placeholder: 'Credit me as (optional)', 'aria-label': 'Name to show on your shared design',
      oninput: function () { state.credit = this.value; onChange(); } });
    wrap = h('div', { class: 'by-share-more' }, [credit, h('p', { class: 'by-muted by-small', text: 'First name or nickname, or leave it blank to stay anonymous. By sharing, you confirm the design is yours (no characters or logos you don\'t own) and let us make it for other customers. We check every design before it goes live.' })]);
    wrap.hidden = true;
    var el = h('div', { class: 'by-share' }, [h('label', { class: 'by-check', for: box.id }, [box, h('span', { html: 'Share my design in <b>Customer Creations</b> so others can buy it' })]), wrap]);
    return {
      el: el,
      sync: function () { box.checked = !!state.share; credit.value = state.credit || ''; wrap.hidden = !state.share; }
    };
  };
  BY.shareProps = function (state, props) {
    props['Share in Customer Creations'] = state.share ? 'Yes' : 'No';
    var c = (state.credit || '').replace(/\s+/g, ' ').trim().slice(0, 30);
    if (state.share && c) props['Credit as'] = c;
    return props;
  };
  BY.store = {
    get: function (k) { try { var v = g.localStorage.getItem('by:' + k); return v ? JSON.parse(v) : null; } catch (e) { return null; } },
    set: function (k, v) { try { g.localStorage.setItem('by:' + k, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } },
    del: function (k) { try { g.localStorage.removeItem('by:' + k); } catch (e) { /* ignore */ } }
  };
  BY.toast = function (msg, kind) {
    var host = document.querySelector('.by-toasts');
    if (!host) { host = BY.h('div', { class: 'by-toasts', role: 'status', 'aria-live': 'polite' }); document.body.appendChild(host); }
    var t = BY.h('div', { class: 'by-toast' + (kind ? ' by-toast--' + kind : ''), text: msg });
    host.appendChild(t);
    setTimeout(function () { t.classList.add('by-toast--out'); }, 2600);
    setTimeout(function () { t.remove(); }, 3100);
  };
  BY.readConfig = function (root) {
    var el = root && root.querySelector('script[type="application/json"][data-by-config]');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  };
  BY.patternUrl = function (cfg, code) {
    var base = (cfg && cfg.patternUrl) || (BY.root() + 'pages/pattern');
    var abs = base.indexOf('http') === 0 ? base : (g.location.origin + base);
    return abs + '#' + code;
  };
  BY.clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  BY.uid = function () { return Math.random().toString(36).slice(2, 10); };
})(window);
